// Stable signed-in destination: no bearer token or public ticket URL in calendars.
export const eventTicketLink = (event) => event?.event_id
  ? `https://app.frontrow-parents.com.au/event/${encodeURIComponent(event.event_id)}/tickets`
  : null;

export const ticketCalendarNote = (event) => {
  const link = eventTicketLink(event);
  return link ? `Tickets in FrontRow (sign-in required): ${link}` : "";
};
